import { Col, Row, Space, Typography } from "antd";
import Banner from "../Banner";
import { FC, useEffect } from "react";

import { useGetMyPortfolioAdverts } from "./ServerSideStates";
import ListItems from "./Components/ListItems";
import PageTitle from "apps/Common/PageTitle";
interface PortfolioIndexProps {
  isMLS?: boolean;
}
const MLSPortfolioIndex: FC<PortfolioIndexProps> = ({ isMLS = true }) => {
  const { Text } = Typography;
  const adverts = useGetMyPortfolioAdverts({
    PageSize: -1,
    IncludeProperties: [
      "User",
      "Store",
      "Currency",
      "Country",
      "City",
      "District",
      "Neighbourhood",
      "AdvertMedia",
      "AdvertMedia.Media",
      "AdvertContactType",
      "AdvertContactType.ContactType",
      
    ],
    SortProperty: "price",
    SortType: "asc",
  });
  // "AdvertOptionAttr",
  useEffect(() => {
    adverts.refetch();
  }, []);

  console.log(adverts)
  return (
    <>
      <Col xs={24}>
        <Row gutter={[0, 20]} className="">
          {isMLS && (
            <>
              <Col xs={24}>
                <Banner />
              </Col>
            </>
          )}
          <Col span={24} className="!flex justify-center">
              <PageTitle
              title="Portföyüm"
              count={adverts?.data?.data?.filteredCount || "0"}
              />
            
          </Col>

          <Col xs={24} className="">
     <ListItems/>
          </Col>
        </Row>
      </Col>
      <></>
    </>
  );
};

export default MLSPortfolioIndex;
